import { useDeletePayoff } from 'hooks/ledger/mutations';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';
import { useHistory, useParams } from 'react-router-dom';
import useAlert from 'utils/alert';

import { useMortgagesContext } from '../../services/context';

const useMortgageDetails = () => {
  const { mortgageId } = useParams<{ mortgageId: string }>();
  const { mortgages } = useMortgagesContext();
  const queryCache = useQueryClient();
  const showAlert = useAlert();
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const { mutate: deleteMortgageMutation, ...deleteMortgageResponse } = useDeletePayoff({
    queryConfig: {
      onSuccess: async () => {
        await queryCache.invalidateQueries(['order-mortgages', id]);
        queryCache.invalidateQueries(['properties-mortgage-payofss', id]);
        history.push(`/orders/details/${id}/payoffs`);
        showAlert(t('payoffs:success-deleted'), 'success');
      },
    },
  });

  return {
    currentMortgage: mortgages.find((f) => f._id === mortgageId),
    deleteMortgageMutation,
    deleteMortgageResponse,
    id,
  };
};

export default useMortgageDetails;
